<div class="pmgraphOuter curved-section-shadow" (clickOutside)="clearCommentRanges($event)">
  <div class="card-heading bg-custom-blue d-flex align-items-center justify-content-between">
    <div class="heading-text">
      <h5>{{'Total Shift Exposure' | translate}} - ({{'Time Series' | translate}})</h5>
    </div>
    <div class="heading-more d-flex align-items-center">
      <ng-content select="[header-actions]"></ng-content>
      <span class="material-icons link-cursor ml-2" (click)="toggleShowChartFilter();">layers</span>
    </div>
    <div (resized)="onResized($event,chart,CHART_DIV_ID)">
      <div id="end-point-chart" style="width: 1px; height: 1px; visibility: hidden"></div>
    </div>
    @if (showChartFilter) {
      <div class="card-box-dd chart-filter" (clickOutside)="hideChartFilter();">
        <div class="row p-2 text-center">
          <div class="col-md-6 p-0">
            <div class="chart-filter-item m-2 pt-2 link-cursor"
              (click)="showNotesRange(taskRangeVisibility); hideChartFilter();">
              <span class="material-icons col-md-12">edit_note</span>
              <span class="title">{{'Notes' | translate}}</span>
            </div>
          </div>
          <div class="col-md-6 p-0 ">
            <div class="chart-filter-item m-2 pt-2 link-cursor"
              (click)="showTaskRange(taskRangeVisibility); hideChartFilter();">
              <span class="material-icons col-md-12">fact_check</span>
              <span class="title">{{'Task' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="row p-2 text-center">
          <div class="col-md-6 p-0">
            <div class="chart-filter-item m-2 pt-2 link-cursor" (click)="hideChartFilter();">
              <span class="material-icons col-md-12">person_pin_circle</span>
              <span class="title">{{'Location' | translate}}</span>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="chart-filter-item m-2 pt-2 link-cursor" (click)="hideChartFilter();">
              <span class="material-icons col-md-12">admin_panel_settings</span>
              <span class="title">PPE</span>
            </div>
          </div>
        </div>
        <div class="row p-2 text-center">
          <div class="col-md-6 p-0">
            <div class="chart-filter-item m-2 pt-2 link-cursor" (click)="showTrendLines();">
              <span class="material-icons col-md-12">format_line_spacing</span>
              <span class="title">{{'Trend Lines' | translate}}</span>
            </div>
          </div>
          <div class="col-md-6 p-0">
            <div class="chart-filter-item m-2 pt-2 link-cursor" (click)="showCumulativeLines();">
              <span class="material-icons col-md-12">show_chart</span>
              <span class="title">{{'Cumulative Line' | translate}}</span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="card-box-dd" [ngClass]="selectedTab===1?'show-graph-tab':'hide-graph-tab'">
    @if (loadCommentsAndNotes) {
      <app-widget-loader></app-widget-loader>
    }
    @if (!loadCommentsAndNotes) {
      <div class="row">
        <div class="col-12">
          <div (resized)="onResized($event,chartDetails,'end-point-chart-details')">
            <div id="end-point-chart-details" class="chart-dimensions"></div>
          </div>
          <div class="row d-flex justify-content-center g-0 video-chart">
            <div [hidden]="isVideoChartHidden" class="col-11" (resized)="onVideoResized($event)">
              <div [id]="CHART_VIDEO_DIV_ID" style="height: 6vh; min-height: 60px;"></div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>